// @flow
import React from 'react'
import cn from 'classnames/bind'
import styles from './Table.module.scss'

const cx = cn.bind(styles)

type Props = {
  children: any,
  className?: string,
  height?: number,
  width?: number,
  hideBorderBottom?: boolean,
} & React.ComponentProps<'div'>

const HeaderRow = ({ children, className, height, width, hideBorderBottom, ...props }: Props) => {
  const style = {
    // $FlowFixMe
    ...(height || height === 0 ? { height } : {}),
    ...(width || width === 0 ? { width } : {}),
  }
  return (
    <div
      className={cx(styles.headerRow, { hideBorderBottom }, className)}
      style={style}
      props={props}
    >
      {children}
    </div>
  )
}

export default HeaderRow
